import axios from "axios";
import { ENDPOINT } from "./endpoints";

export default class ServicioRest {
  diplomasPaginados(token, page, pageLength, orden, ordenarPor, filtros) {
    if (ordenarPor != null) {
      return axios.get(ENDPOINT + "/diplomaspg?page=" + page + "&pageLength=" + pageLength + "&order=" + orden + "&orderBy=" + ordenarPor + "&" + filtros, { "headers": { "auth-token": token } }).then((response) => response.data);
    }
    
    return axios.get(ENDPOINT + "/diplomaspg?page=" + page + "&pageLength=" + pageLength + "&" + filtros, { "headers": { "auth-token": token } }).then((response) => response.data);
  }

  diplomaPdf(curso, token) {
    return axios.get(ENDPOINT + "/diplomapdf/" + curso,  { "headers": { "auth-token": token } }).then((response) => response.data);
  }


  actividadesAlumno(token) {
    return axios.get(ENDPOINT + "/actividades", { "headers": { "auth-token": token } }).then((response) => response.data);
  }

  previsualizacion(curso, token) {
    return axios.get(ENDPOINT + "/previsualizacion/" + curso, { "headers": { "auth-token": token } }).then((response) => response.data);
  }

  correoAlumno(curso, token) {
    return axios.get(ENDPOINT + "/correo/" + curso, { "headers": { "auth-token": token } } ).then((response) => response.data);
  }

  anulaDiploma(diplomaContext, token) {
    return axios.post(ENDPOINT + "/anuladiploma", diplomaContext, { "headers": { "auth-token": token } }).then(response => response.data);
  }

  generacion(diplomaContext, token) {
    return axios.post(ENDPOINT + "/generacion", diplomaContext, { "headers": { "auth-token": token } }).then(response => response.data);
  }

  obtenerResolucion(numSolicitud, token) {
    return axios.get(ENDPOINT + "/obtenerResolucion/" + numSolicitud, { "headers": { "auth-token": token } }).then(response => response.data);
  }

  login(token) {
    return axios.get(ENDPOINT + "/login", { "headers": { "auth-token": token } }).then((response) => response.data);
  }

  health() {
    return axios.get(ENDPOINT + "/health" ).then((response) => response.data);
  }
  
  //CURSOS-1152
  guardarDatosEstudiante(cursosErrorDiplomaContext, token) {
    return axios.post(ENDPOINT + "/guardardatosestudiante", cursosErrorDiplomaContext, { "headers": { "auth-token": token } }).then(response => response.data);
  }

}
